/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requestspending1Inputs */

const en_requestspending1 = /** @type {(inputs: Requestspending1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

const de_requestspending1 = /** @type {(inputs: Requestspending1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offen`)
};

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Requestspending1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestspending1 = /** @type {((inputs?: Requestspending1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestspending1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestspending1(inputs)
	return de_requestspending1(inputs)
});
export { requestspending1 as "requestsPending" }